import React from 'react';

const EditRewardIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      width="18"
      height="17"
      viewBox="0 0 18 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        // fill-rule="evenodd"
        // clip-rule="evenodd"
        d="M14 2.02393C13.6969 2.02393 13.4063 2.14432 13.192 2.35863L2.8977 12.6529L2.35899 14.8077L4.51382 14.269L14.8081 3.97475C14.9142 3.86863 14.9984 3.74266 15.0558 3.60401C15.1132 3.46536 15.1428 3.31676 15.1428 3.16669C15.1428 3.01662 15.1132 2.86802 15.0558 2.72937C14.9984 2.59073 14.9142 2.46475 14.8081 2.35863C14.702 2.25252 14.576 2.16834 14.4373 2.11091C14.2987 2.05348 14.1501 2.02393 14 2.02393ZM12.3081 1.47475C12.7568 1.02602 13.3654 0.773926 14 0.773926C14.3142 0.773926 14.6254 0.835817 14.9157 0.956064C15.206 1.07631 15.4698 1.25256 15.692 1.47475C15.9141 1.69694 16.0904 1.96072 16.2106 2.25102C16.3309 2.54132 16.3928 2.85247 16.3928 3.16669C16.3928 3.48092 16.3309 3.79206 16.2106 4.08237C16.0904 4.37267 15.9141 4.63645 15.692 4.85863L5.27529 15.2753C5.19519 15.3554 5.09483 15.4122 4.98493 15.4397L1.6516 16.273C1.43861 16.3263 1.21331 16.2639 1.05807 16.1086C0.902834 15.9534 0.840428 15.7281 0.893674 15.5151L1.72701 12.1818C1.75448 12.0719 1.81131 11.9715 1.8914 11.8914L12.3081 1.47475ZM8.37501 15.6667C8.37501 15.3216 8.65484 15.0417 9.00001 15.0417H16.5C16.8452 15.0417 17.125 15.3216 17.125 15.6667C17.125 16.0119 16.8452 16.2917 16.5 16.2917H9.00001C8.65484 16.2917 8.37501 16.0119 8.37501 15.6667Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default EditRewardIcon;
